import Footer from './Footer'

export const ContainerWrapper = ({ children, isHeader }) => {
    const conatinerClass = isHeader ? 'container m-auto' : 'container m-auto'
    return <div className={conatinerClass}>{children}</div>
}

export const Container = ({ children, footer = true }) => {
    return (
        <>
            <ContainerWrapper>
                <div className="py-10 px-5 md:px-0">{children}</div>
            </ContainerWrapper>
            {footer && <Footer />}
        </>
    )
}
